export const DATE_MASK = 'dd.MM.yyyy'
export const API_DATE_MASK = 'yyyy-MM-dd'
export const MASK_CHAR = '_'
